/**
 * The default bundle app ID to use if no bundle app ID is found in localStorage.
 * Must be defined in admin-app/src/CapacitorAppConfigs.js
 */
export const DEFAULT_APP_CONFIG = 'com.vayadriving' as const;

/**
 * The key used to store the cached bundle app ID in localStorage.
 * Not exported because we want people using these accessors here.
 */
const cacheKey = 'bundleAppId' as const;

/**
 * Get the cached bundle app ID from localStorage
 */
export const getCachedBundleAppId = (): string => {
	const cached = window.localStorage.getItem(cacheKey);
	if (cached) {
		return cached;
	}
	return DEFAULT_APP_CONFIG;
};

/**
 * Set the cached bundle app ID in localStorage
 */
export const setCachedBundleAppId = (bundleAppId: string): void => {
	window.localStorage.setItem(cacheKey, bundleAppId);
};
